// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"648":"0de1bb9a","726":"9fea0391","837":"77a10b56","925":"984bda15","956":"880b6ee3","962":"f8d7551e","981":"476df19c"}[chunkId] + ".css";
};